import { cx } from "class-variance-authority";
import { Clamp } from "../Clamp/Clamp";
import { Caret } from "../Caret/Caret";

import * as styles from "./MoreInfo.module.scss";

type ExpandInfoProps = {
  className?: string;
  isExpanded?: boolean;
  onClick?: () => void;
  direction?: "horizontal" | "vertical";
};

const MoreInfo = ({
  className,
  isExpanded,
  onClick,
  direction = "vertical",
}: ExpandInfoProps) => {
  return (
    <Clamp
      variant={`grey`}
      className={cx(styles.caret, className)}
      onClick={(e) => {
        if (onClick) {
          onClick();
          e.stopPropagation();
        }
      }}
    >
      {direction === "vertical" ? (
        <Caret variant={isExpanded ? "up" : "down"} />
      ) : (
        <Caret variant={isExpanded ? "left" : "right"} />
      )}
    </Clamp>
  );
};

export { MoreInfo };
